// =======================
// MULTI COLUMN
// MULTI IMAGE  ( V3 - V2 Is only single image )
// delivery trucks
//
//Deleivery driver
//https://plus.unsplash.com/premium_photo-1682088432727-ecbc08381a63?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D
//delivery
//https://images.unsplash.com/photo-1620455800201-7f00aeef12ed?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D
// =======================
import React, { useEffect, useRef, useState } from 'react';
import { Card, Container, Row, Col, ListGroup } from 'react-bootstrap';


//import insuranceData from './InsuranceData-Personal_v03-Images-stock.json';
// import insuranceData from './InsuranceData-Business_v03a-Images-stock.json';
import "./BizServicesListImagesMultiColumn_v03.css"

import { IAppConfig } from "../App_v01_Interfaces";
interface AppConfigProps{
  appConfig: IAppConfig;
}


interface InsuranceItem_original {
  title: string;
  description: string;
  benefits: string[];
  example: string;
  imageUrls: string[];
  alt: string;
}

interface IBusinessServicesDataProps{
  bizServicesData: IBizServicesList;
}//end:

interface IBizServicesList {
  title: string;
  subTitle: string;
  businessServices: IBizServiceItem[];
}

interface IBizServiceItem {
  title: string;
  description: string;
  benefits: string[];
  example: string;
  imageUrls: {
    altText: string;
    url: string;
  }[];
}


//const BizServicesListImagesMultiColumn_v03: React.FC<IBusinessServicesDataProps> = ({BizServicesData: BizServicesData}) => {
const BizServicesListImagesMultiColumn_v03: React.FC<IBusinessServicesDataProps> = ({bizServicesData: BizServices_DATA}) => {

  return (
    <Container fluid className="my-5">
      <h1 className="mb-4 text-center">{BizServices_DATA.title}</h1>
      <h4 className="mb-4 text-center">{BizServices_DATA.subTitle}</h4>
      {/* <Row xs={1} md={2} className="g-4"> */}
      <Row xs={1} sm={2} xl={3} xxl={5} className="g-4">
        {BizServices_DATA.businessServices.map((item: IBizServiceItem, index: number) => (
          <Col key={index}>
            <ImageCarouselCard item={item} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

const ImageCarouselCard: React.FC<{ item: IBizServiceItem }> = ({ item }) => {

  const [imageIndex, setImageIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (!paused) {
      intervalRef.current = setInterval(() => {
        setImageIndex((prevIndex) => (prevIndex + 1) % item.imageUrls.length);
      }, 7000);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [paused, item.imageUrls.length]);

  const handleMouseEnter = () => setPaused(false);//SET THIS TO TRUE TO PAUSE ON HOVER
  const handleMouseLeave = () => setPaused(false);

  return (

    // <Card className="shadow-sm h-100  hover-border rounded-top-3" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
    <Card className="shadow-sm h-100  hover-border rounded-top-3">
      {/* <Card.Img
        variant="top"
        src={item.imageUrls[imageIndex]}
        alt={item.alt}
        className="img-fluid"
        style={{ height: '200px', objectFit: 'cover' }}
      /> */}


        <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
        {item.imageUrls.map((imageUrl, idx) => (

       

            <img
            key={idx}
            src={imageUrl.url}
            alt={imageUrl.altText}
            
            className="fade-image rounded-top-3"
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: imageIndex === idx ? 1 : 0,
                transition: 'opacity 5s ease-in-out'
            }}
            />

            

        ))}
        </div>


      <Card.Body>
        <Card.Title className="text-primary">{item.title}</Card.Title>
        <Card.Text><strong>Description:</strong> {item.description}</Card.Text>
        <div className="mb-2">
          <strong>Benefits:</strong>
          <ListGroup variant="flush" className="mt-1">
            {item.benefits.map((benefit, bIndex) => (
              <ListGroup.Item key={bIndex}>{benefit}</ListGroup.Item>
            ))}
          </ListGroup>
        </div>
        <Card.Text className="mt-2"><strong>Example:</strong> {item.example}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default BizServicesListImagesMultiColumn_v03;
